<style lang="less">
.cell-detail-container {
  width: 100%;
  height: 100%;
  background: #f7f7f7;
  font-family: PingFangSC-Semibold;
  .van-hairline--surround::after{
    border: none;
  }
  .detail-header {
    position: relative;
    .return-box {
      width: 100px;
      height: 100px;
      position: absolute;
      left: 24px;
      top: 36px;
      display: flex;
      align-items: center;
      z-index: 9999;
    }
    .return-box-ipx {
      width: 100px;
      height: 100px;
      position: absolute;
      display: flex;
      align-items: center;
      left: 24px;
      top: 84px;
      z-index: 9999;
    }
    .header-return {
      width: 36px;
      height: 36px;
    }
    .header-img {
      width: 100%;
      height: 270px;
    }
    .header-img-ipx {
      width: 100%;
      height: 318px;
    }
    .header-info-ipx {
      width: 100%;
      position: absolute;
      left: 0;
      top: 166px;
    }
    .header-info {
      width: 100%;
      position: absolute;
      left: 0;
      top: 118px;
      display: flex;
      align-content: flex-start;
      align-items: center;
      height: 78px;
      line-height: 78px;
      .long-str{
        margin-bottom: 50px;
      }
    }
    .area-title {
      max-width: 450px;
      height: 60px;
      font-size: 44px;
      font-weight: 600;
      color: rgba(35, 44, 55, 1);
      line-height: 60px;
      text-align: left;
      margin-left: 40px;
      margin-right: 16px;
    }
    .operation-btn{
      background: #fff;
      width:96px;
      height:40px;
      line-height: 40px;
      font-size:22px;
      border-radius:4px;
      padding: 0;
    }
    .finished{
      color: #BDC3CE;
      border: 2px solid #BDC3CE;
      margin-left: 14px;
    }
    .contrast{
      color: #4169E1;
      border: 2px solid #4169E1;
    }
    .attention{
      color: #F5670B;
      border: 2px solid #F5670B;
      margin-left: 14px;
    }
    .business-circle{
      position: absolute;
      left: 40px;
      bottom: 40px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height:36px;
      line-height:45px;
      .business-circle-img{
        width: 24px;
        height: 28px;
      }
      .business-circle-dec{
        font-size:26px;
        color:rgba(137,147,159,1);
        margin-left: 8px;
      }
    }
  }
  .detail-main {
    padding: 0 16px;
    width: 718px;
    .detail-area-score {
      padding: 24px 24px 0;
      .detail-area-score-title {
        width: 670px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .area-score {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .score {
            height: 36px;
            line-height: 36px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: rgba(245, 103, 11, 1);
            border-radius: 6px;
            font-size: 28px;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            margin-left: 6px;
            padding: 0 10px;
            .score-img {
              width: 16px;
              height: 24px;
              margin-right: 6px;
            }
          }         
        }
        .month-ranking {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          font-size: 26px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(35, 44, 55, 1);
          height: 36px;
          line-height: 36px;
          .ranking-title {
            color: #89939F;
          }
          .ranking-img {
            width: 10px;
            height: 16px;
            margin-left: 6px;
          }
        }
      }
      .area-score-content {
        margin: 34px 0;
        .score-box {
          padding: 8px 32px;
        }
      }
      .area-score-footer {
        height: 90px;
        border-top: 1px solid #efefef;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .area-score-footer-left {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          height: 36px;
          line-height: 36px;
          .footer-left-img {
            width: 34px;
            height: 28px;
          }
          .footer-left-text {
            font-size: 26px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(137, 147, 159, 1);
            line-height: 36px;
            margin-left: 14px;
          }
        }
      }
    }
    .detail-traffic {
      padding: 24px;
      margin-top: 18px;
      .traffic-count-box {
        margin-top: 34px;
        padding: 0 48px;
        border-bottom: 2px solid #efefef;
        margin-bottom: 20px;
        .traffic-count-show {
          .traffic-count {
            margin-top: 12px;
            width: 70px;
            height: 54px;
            line-height: 54px;
            text-align: center;
          }
        }
      }
      .mask-map {
        width: 100%;
        height: 100%;
      }
      .walking-index{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 34px;
        margin-bottom: 20px;
      }
      .walking-index-info{
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        .walking-index-left{
          width: 188px;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .circle-nei {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .draw_btn {
              font-size: 62px;
              font-family: Arial-BoldMT;
              font-weight: normal;
              color: rgba(65, 105, 225, 1);
              line-height: 72px;
            }
          }
          .circle-dec{
            color: #89939F;
            margin-top: 28px;
            width:110px;
            text-align: center;
          }
        }
        .walking-index-right{
          margin-left: 42px;
          .village-progress {
            .progress-title {
              float: left;
              width: 70px;
              height: 50px;
              font-size: 26px;
              color: rgba(137, 147, 159, 1);
              line-height: 50px;
              text-align: left;
            }
            .progress_wrapper {
              height: 50px;
              display: flex;
              align-items: center;
              justify-content: flex-end;
            }
            .progress {
              width: 348px;
              height: 26px;
              color: #f5a623;
              border-radius: 14px;
            }
            .van-progress {
              background: #f7f7f7;
            }
            .van-progress__portion--with-pivot {
              border-radius: 14px;
            }
          }
        }
      }
    }
    .cell-info{
      padding: 24px;
      margin-top: 28px;
      .cell-info-desc{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 16px;
        margin-bottom: 16px;
        .cell-info-item{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          width: 310px;
          .cell-info-name{
            color: #89939F;
            min-width: 104px;
            margin-right: 10px;
            text-align: left;
          }
          .cell-info-value{
            color: #232C37;
            text-align: left;
          }
        }
      }
      .cell-info-more{
        .more-img{
          width: 22px;
          height: 16px;
        }
      }
    }
    .industry-development {
      padding: 24px 24px 60px;
      margin-top: 18px;
      .development-box-wrapper {
        margin: 34px 100px 0;
      }
      .development-echarts {
        position: relative;
        width: 670px;
        height: 600px;
        ec-canvas {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
        }
      }
      .development-dec {
        font-size: 26px;
        color: rgba(35, 44, 55, 1);
        line-height: 36px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        .dec-dian {
          font-weight: bold;
          margin-right: 10px;
        }
      }
    }
    .surrounding-area{
      padding: 24px;
      margin-top: 18px;
      .swiper-box{
        margin-top: 34px;
      }
      .slide-img{
        width:224px;
        height:140px;
      }
      .slide-dec{
        color:#232C37;
        margin-top: 16px;
        text-align: left;
      }
    }
  }
  .detail-footer {
    height: 102px;
    line-height: 102px;
    text-align: center;
    color: #BDC3CE;
    font-size: 26px;
  }
.score-info {
  width: 26px;
  height: 26px;
  margin-left: 8px;
}
.title {
  font-size: 32px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(35, 44, 55, 1);
  line-height: 44px;
  text-align: left;
}
.subhead {
  height: 36px;
  font-size: 26px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: #232c37;
  line-height: 36px;
  text-align: left;
}
.footer-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .footer-right-img {
    width: 14px;
    height: 18px;
  }
  .footer-right-text {
    height: 36px;
    font-size: 26px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(65, 105, 225, 1);
    line-height: 36px;
    margin-right: 4px;
  }
}
.common-box-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .common-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .common-title {
      height: 36px;
      font-size: 26px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(137, 147, 159, 1);
      line-height: 36px;
      margin-bottom: 10px;
    }
    .common-info {
      height: 44px;
      font-size: 32px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      line-height: 44px;
    }
  }
}
.main-wrapper {
  background: #fff;
  width: 670px;
  box-shadow: 0px 0px 4px 0px rgba(219, 219, 219, 0.5);
  border-radius: 6px;
}
#detail_map {
  width: 100%;
  height: 308px;
}
.van-popup {
  border-radius: 8px;
  width: 560px;
}
.popup-box {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 22px 38px 40px;
  // height: 656px;
  // overflow-y: scroll;
  .dialog-title {
    height: 44px;
    font-size: 32px;
    color: rgba(35, 44, 55, 1);
    line-height: 44px;
    margin: 16px 0;
    font-weight: bold;
  }
  .dialog-info {
    text-align: left;
    font-size: 28px;
    color: rgba(111, 120, 132, 1);
    line-height: 40px;
  }
}
.modal-btn-wrapper {
  display: flex;
  flex-direction: row;
  height: 100px;
  line-height: 100px;
  border-top: 2px solid rgba(7, 17, 27, 0.1);
  background: #fff;
}
.confirm-btn {
  flex: 1;
  height: 90px;
  line-height: 90px;
  text-align: center;
  font-size: 32px;
}
.selected {
  color: #4169e1;
  border-bottom: 2px solid #4169e1;
}
.bottom-top{
  margin-top: 28px;
}
.swiper-slide {
  width: 32%;
}
.contrast-box{
    position: fixed;
    right: 16px;
    bottom: 130px;
    width:84px;
    height:84px;
    background:rgba(35,44,55,1);
    box-shadow:0px 4px 10px 0px rgba(35,44,55,0.3);
    border-radius:6px;
    opacity:0.8;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 1999;
    .contrast-img{
        width: 40px;
        height: 40px;
    }
    .contrast-dec{
        font-size:24px;
        color:rgba(255,255,255,1);
    }
    .contrast-marker-box{
        position: absolute;
        left: -10px;
        top: -10px;
        width:32px;
        height:32px;
        line-height: 32px;
        text-align: center;
        border-radius: 32px;
        background:rgb(65,105,225);
        border:2px solid rgba(247,247,247,1);
        .contrast-marker{
            font-size: 24px;
            color: #fff;
        }
    }
}
.matching-box{
  height: 82vh;
  padding-left: 24px;
  .match-title{
    font-size:34px;
    color: #312D2D;
    font-weight:600;
    margin-top: 20px;
  }
  .match-item{
    border-bottom: 2px solid #EEEEEE;
    text-align: left;
    padding-top: 12px;
    padding-bottom: 20px;
    .match-type{
      margin-top: 16px;
      .match-item-type{
        font-size:32px;
        font-family:PingFangSC-Semibold;
        font-weight:600;
        color:rgba(35,44,55,1);
      }
      .match-item-scope{
        font-size:24px;
        color: #F5A623;
        margin-left: 10px;
        font-family:PingFangSC-Medium;
        font-weight:500;
      }
    }
    .match-content{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .match-content-item{
        margin-top: 26px;
        margin-right: 80px;
        .match-content-name{
          font-size:26px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(111,120,132,1);
        }
        .match-content-value{
          font-size:24px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(111,120,132,1);
          margin-left: 10px;
        }
      }
    }
  }
}
.match-close-btn{
  width: 50px;
  height: 50px;
  line-height: 50px;
  position: fixed;
  top: 19px;
  right: 30px;
  .match-close-btn-img{
    width: 24px;
    height: 24px;
  }
}
.shu{
  width: 2px;
  height: 26px;
  background-color:rgba(137,147,159,1);
  margin-left: 12px;
  margin-right: 6px;
}
}
</style>
<template>
  <div class="cell-detail-container">
    <div class="detail-header">
      <img :class="isIpx?'header-img-ipx':'header-img'" src="../../assets/img/buss-background.png">
      <div :class="isIpx?'header-info-ipx':'header-info'">
        <div v-if="zoneDetail.name&&zoneDetail.name.length>10" class="long-str">
          <div class="area-title">{{zoneDetail.name.slice(0,10)}}</div>
          <div class="area-title">{{zoneDetail.name.slice(10,20)}}</div>
        </div>
        <div class="area-title" v-else>{{zoneDetail.name}}</div>
        <van-button plain hairline class="operation-btn" :class="hasContrast?'finished':'contrast'" :disabled="hasContrast?true:false" @click="plusContrast">{{hasContrast?'已对比':'+ 对比'}}</van-button>
        <van-button plain hairline class="operation-btn" :class="hasAttention||zoneDetail.isCare==1?'finished':'attention'" :disabled="hasAttention||zoneDetail.isCare==1?true:false" @click="plusAttention(zoneDetail)">{{hasAttention||zoneDetail.isCare==1?'已关注':'+ 关注'}}</van-button>
      </div>
      <div class="business-circle">
        <img class="business-circle-img" src="../../assets/img/location1.png" />
        <span class="business-circle-dec">{{zoneDetail.area}}-{{zoneDetail.zone}}</span>
        <div class="shu"></div>
        <span class="business-circle-dec" v-if="zoneDetail.completeTime">{{zoneDetail.completeTime}}年建成</span>
      </div>
    </div>
    <div class="detail-main">
      <div class="detail-area-score main-wrapper">
        <div class="detail-area-score-title">
          <div class="area-score">
            <div class="title">小区得分</div>
            <div class="score">
              <img class="score-img" src="../../assets/img/score.png" />
              <label>{{zoneDetail.score}}分</label>
            </div>
            <img class="score-info" @click="lookScore" src="../../assets/img/wenhao.png" />
          </div>
          <div class="month-ranking" v-debounce="toRank">
            <div class="ranking-title">超越全市{{parseInt(zoneDetail.rank*100)}}%小区</div>
            <img class="ranking-img" src="../../assets/img/right_hui.png" />
          </div>
        </div>
        <div class="area-score-content common-box-wrapper">
          <div class="score-box common-box">
            <div class="score-title common-title">月租金</div>
            <div class="area-score-info common-info" v-if="zoneDetail.unitRentPrice">{{zoneDetail.unitRentPrice}}元/平米</div>
            <div class="area-score-info common-info" v-else>——</div>
          </div>
          <div class="score-box common-box">
            <div class="score-title common-title">挂牌量</div>
            <div class="area-score-info common-info">{{zoneDetail.houseNum?zoneDetail.houseNum:'——'}}</div>
          </div>
          <div class="score-box common-box">
            <div class="score-title common-title">挂牌周期</div>
            <div class="area-score-info common-info" v-if="zoneDetail.activeDate">{{zoneDetail.activeDate}}天</div>
            <div class="area-score-info common-info" v-else>——</div>
          </div>
        </div>
        <div class="area-score-footer">
          <div class="area-score-footer-left">
            <img class="footer-left-img" src="../../assets/img/hzf-log.png" />
            <div class="footer-left-text">会找房商业决策应用中心</div>
          </div>
          <div class="footer-right" v-debounce="goMarketPrice">
            <div class="footer-right-text">详细市场分析</div>
            <img class="footer-right-img" src="../../assets/img/right.png" />
          </div>
        </div>
      </div>
      <div class="detail-traffic main-wrapper">
        <div class="title">交通配套</div>
        <div class="traffic-count-box common-box-wrapper">
          <div
            class="traffic-count-show common-box"
            v-for="(item,index) in trafficList"
            :key="index"
            @click="selectTraffic(item,index)"
          >
            <div class="traffic-name common-title">{{item.name}}</div>
            <div class="traffic-count common-info"
              :style="index==currentIndex?'color:#4169e1;border-bottom: 1px solid #4169e1;':''"
            >{{item.value}}</div>
          </div>
        </div>
        <div id="detail_map" v-debounce="goTraffic"></div>
        <div class="walking-index">
          <div class="subhead">步行指数</div>
          <img class="score-info" @click="lookScoreIndex" src="../../assets/img/wenhao.png" />
        </div>
        <div class="walking-index-info">
          <div class="walking-index-left" ref="circle-box">
            <van-circle
              v-model="currentRate"
              color="#4169E1"
              fill="#fff"
              size="94px"
              layer-color="#ebedf0"
              :text="String(walkIndex.totalScore)"
              :speed="80"
              :clockwise="true"
              :stroke-width="30"
              :rate="walkIndex.totalScore"
            >
              <div class="circle-nei">
                <div class="draw_btn">{{walkIndex.totalScore}}</div>
              </div>
            </van-circle>
            <div class="circle-dec">超越全市{{parseInt(walkIndex.rank*100)}}%小区</div>
          </div>
          <div class="walking-index-right">
            <div class="village-progress" v-for="(item,index) in progressList" :key="index">
              <div class="progress-title">{{item.name}}</div>
              <div class="progress_wrapper">
                <Progress
                  class="progress"
                  :percentage="item.value"
                  :pivot-text="item.value?item.value+'分':0+'分'"
                  text-color="#F5A623"
                  pivot-color="rgba(255,255,255,0)"
                  color="#F5A623"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="footer-right bottom-top" @click="openMatching">
          <div class="footer-right-text">配套详细分类</div>
          <img class="footer-right-img" src="../../assets/img/right.png" />
        </div>
      </div>
      <div class="cell-info main-wrapper">
        <div class="title">小区概况</div>
        <div class="cell-info-top">
          <div class="cell-info-desc">
            <div class="cell-info-item">
              <span class="cell-info-name">所属区域</span>
              <span class="cell-info-value">{{cellInfoList.area?cellInfoList.area:'——'}}</span>
            </div>
            <div class="cell-info-item">
              <span class="cell-info-name">建成年代</span>
              <span class="cell-info-value" v-if="cellInfoList.completeTime&&cellInfoList.completeTime!=0">{{cellInfoList.completeTime}}年</span>
              <span class="cell-info-value" v-else>——</span>
            </div>
          </div>
          <div class="cell-info-desc">
            <div class="cell-info-item">
              <span class="cell-info-name">楼 栋 数</span>
              <span class="cell-info-value" v-if="cellInfoList.buildingCount&&cellInfoList.buildingCount!=0">{{cellInfoList.buildingCount}}栋</span>
              <span class="cell-info-value" v-else>——</span>
            </div>
            <div class="cell-info-item">
              <span class="cell-info-name">总 户 数</span>
              <span class="cell-info-value" v-if="cellInfoList.houseCount&&cellInfoList.houseCount!=0">{{cellInfoList.houseCount}}户</span>
              <span class="cell-info-value" v-else>——</span>
            </div>
          </div>
          <div class="cell-info-desc">
            <div class="cell-info-item">
              <span class="cell-info-name">供暖方式</span>
              <span class="cell-info-value">{{cellInfoList.withHeating}}</span>
            </div>
            <div class="cell-info-item" v-if="!noMore">
              <span class="cell-info-name">产权年限</span>
              <span class="cell-info-value" v-if="cellInfoList.buildingLife&&cellInfoList.buildingLife!=0">{{cellInfoList.buildingLife}}年</span>
              <span class="cell-info-value" v-else>——</span>              
            </div>
          </div>
        </div>
        <div class="cell-info-bottom" v-if="!noMore">
          <div class="cell-info-desc">
            <div class="cell-info-item">
              <span class="cell-info-name">停 车 位</span>
              <span class="cell-info-value" v-if="cellInfoList.parkInfo">{{cellInfoList.parkInfo}}</span>
              <span class="cell-info-value" v-else>——</span>
            </div>
            <div class="cell-info-item">
              <span class="cell-info-name">有无电梯</span>
              <span class="cell-info-value">{{cellInfoList.elevator&&cellInfoList.elevator!=0?cellInfoList.elevator:'——'}}</span>
            </div>
          </div>
          <div class="cell-info-desc">
            <div class="cell-info-item">
              <span class="cell-info-name">绿 化 率</span>
              <span class="cell-info-value" v-if="cellInfoList.greenRate&&cellInfoList.greenRate!=0">{{cellInfoList.greenRate}}%</span>
              <span class="cell-info-value" v-else>——</span>
            </div>
            <div class="cell-info-item">
              <span class="cell-info-name">容 积 率</span>
              <span class="cell-info-value" v-if="cellInfoList.plotRati&&cellInfoList.plotRati!=0">{{cellInfoList.plotRati}}%</span>
              <span class="cell-info-value" v-else>——</span>
            </div>
          </div>
          <div class="cell-info-desc">
            <div class="cell-info-item">
              <span class="cell-info-name">物业公司</span>
              <span class="cell-info-value">{{cellInfoList.propertyName?cellInfoList.propertyName:'——'}}</span>
            </div>
            <div class="cell-info-item">
              <span class="cell-info-name">物 业 费</span>
              <span class="cell-info-value" v-if="cellInfoList.propertyFee">{{cellInfoList.propertyFee}}元/㎡/月</span>
              <span class="cell-info-value" v-else>——</span>
            </div>
          </div>
        </div>
        <div class="cell-info-more" @click="getMore" v-if="noMore">
          <img class="more-img" src="../../assets/img/more-info.png" />
        </div>
        <div class="cell-info-more" @click="backMore" v-else>
          <img class="more-img" src="../../assets/img/retract.png" />
        </div>
      </div>
      <div class="industry-development main-wrapper">
        <div class="title">行业发展</div>
        <div class="development-box-wrapper common-box-wrapper">
          <div class="development-box common-box">
            <div class="development-title common-title">中介公司</div>
            <div class="development-info common-info">{{developmentInfo.agencyNum}}</div>
          </div>
          <div class="development-box common-box">
            <div class="development-title common-title">经纪人</div>
            <div class="development-info common-info">{{developmentInfo.brokerNum}}</div>
          </div>
        </div>
        <div class="development-echarts" v-if="pieData.length>0">
          <div ref="detailPie" style="height: 100%"></div>
        </div>
        <div style="text-align:center;margin:20px 0;" v-else>暂无数据</div>
        <div class="development-dec" v-if="apartmentInfo.length>0">
          <div class="dec-dian">·</div>
          <div class="dec-info">
            已入驻明星品牌公寓：
            <label
              v-for="(item,index) in apartmentInfo"
              :key="index"
            >{{item}}{{index==apartmentInfo.length-1?'':'、'}}</label>
          </div>
        </div>
      </div>
      <div class="surrounding-area main-wrapper" v-if="nearCellList.length>0">
        <div class="title">周边小区推荐</div>
        <swiper :options="swiperOption" class="swiper-box">
          <swiper-slide v-for="(item,index) in nearCellList" :key="index">
            <img class="slide-img" @click="goOtherCell(item)" :src="item.img" :onerror="defaultImg" />
            <div class="slide-dec">{{item.name}}</div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="detail-footer">收房会选址 · 出房不发愁</div>
    <van-popup v-model="show">
      <div class="popup-box">
        <div class="dialog-title">选址评分</div>
        <div
          class="dialog-info"
        >选址评分是业务团队深入了解合作商家，进行实地探访，将其在长租行业的选址经验整合沉淀、量化各类信息维度，经算法分析形成的结果。选址评分主要通过对城市配套和市场表现两个方面进行评估，满分为100分，得分越高，越适合长租公寓运营商收房选址。</div>
        <div class="dialog-title">评分维度说明</div>
        <div
          class="dialog-info"
        >城市配套是指区域范围内的居住条件，包括内部小区品质、周边的交通、生活配套，以及企业和职工密集度等市场表现是指该区域的租房市场体量、实际需求量，和长租市场发展潜力等</div>
      </div>
      <div class="modal-btn-wrapper">
        <div class="confirm-btn" style="color:#4169E1" @click="confirmPopup">知道了</div>
      </div>
    </van-popup>
    <van-popup v-model="showIndex">
      <div class="popup-box">
        <div class="dialog-title">什么是步行指数</div>
        <div
          class="dialog-info"
        >通过步行时间来衡量小区周边的便利程度。综合了包含交通、生活、娱乐、医疗、教育等18个细分配套项的测评结果。</div>
        <div class="dialog-title">评分机制</div>
        <div
          class="dialog-info"
        >测量通往附近便利设施的步行路线，根据每类设施的距离授予积分。步行5分钟以内的便利设施享受最高积分。并根据衰减函数，步行时间超过30分钟的便利设施不得分。满分为100分，得分越高便利程度越高。</div>
      </div>
      <div class="modal-btn-wrapper">
        <div class="confirm-btn" style="color:#4169E1" @click="showIndex=false">知道了</div>
      </div>
    </van-popup>
    <van-popup style="width:100%;" v-model="showMatching" position="bottom">
      <div class="matching-box">
        <div class="match-title">配套详细分类</div>
        <ul>
          <li class="match-item" :style="index==matchList.length-1?'border:none':''" v-for="(item,index) in matchList" :key="index">
            <div class="match-type">
              <span class="match-item-type">{{item.type}}</span>
              <span class="match-item-scope">{{item.scope}}分</span>
            </div>
            <ul class="match-content">
              <li class="match-content-item" v-for="(n,i) in item.info" :key="i">
                <span class="match-content-name">{{n.name}}</span>
                <span class="match-content-value">{{n.value}}分</span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="match-close-btn" @click="closeMatch">
        <img class="match-close-btn-img" src="../../assets/img/close.png" />
      </div>
    </van-popup>
    <div class="contrast-box" @click.stop="goContrast">
      <img class="contrast-img" src="../../assets/img/contrast.png" />
      <span class="contrast-dec">对比</span>
      <div class="contrast-marker-box">
        <span class="contrast-marker">{{contrastCount}}</span>
      </div>
    </div>
  </div>
</template>

<script>
var map;
let timestampStart,timestampEnd;
import { Dialog, Popup, Toast, Circle, Progress, Button } from "vant";
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: "detail",
  components: {
    Progress,
    "van-popup": Popup,
    "van-circle":Circle,
    "van-button":Button,
    swiper,
    swiperSlide
  },
  inject:['reload'],
  data() {
    return {
      isIpx: false,
      show: false,
      showIndex:false,
      pieData: [],
      trafficList: [],
      currentIndex: 0,
      latitude: 40.072029,
      longitude: 116.360235,
      markers: [],
      trafficName: "",
      scale: 14,
      polygons: [],
      apartmentInfo: [],
      zoneDetail: {},
      developmentInfo: {},
      isShare: 0,
      zoneId: 0,
      cityId: 0,
      currentRate:0,
      progressList:[],
      noMore:true,
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 9
      },
      hasContrast:false,
      hasAttention:false,
      showMatching:false,
      matchList:[{
          type:'教育',
          scope:99,
          info:[]
        },{
          type:'医疗',
          scope:99,
          info:[]
        },{
          type:'购物',
          scope:99,
          info:[]
        },{
          type:'生活',
          scope:99,
          info:[]
        },{
          type:'娱乐',
          scope:99,
          info:[]
        },{
          type:'交通',
          scope:99,
          info:[]
        }],
      nearCellList:[],
      walkIndex:{},
      cellInfoList:{},
      contrastCount:0,
      userId: ''
    };
  },
  computed: {
    defaultImg () {
      return 'this.src="'+ require('../../assets/img/default-img.png') +'"'
    }
  },
  directives: {
   debounce: {
    inserted: function (el, binding) {
     let timer
     el.addEventListener('click', () => {
      if (timer) {
       clearTimeout(timer)
      }
      timer = setTimeout(() => {
       binding.value()
      }, 500)
     })
    }
   }
  },
  created() {
    timestampStart = (new Date()).getTime();
    this.addBuried({
      source:'1',
      eventType: '曝光事件',
      eventContent: '小区详情'
    });
    let options = this.$route.query;
    this.latitude = options.latitude;
    this.longitude = options.longitude;
    this.zoneId = options.zoneId;
    this.cityId = options.cityId;
    if (options.userId) {
      this.userId = options.userId;
      localStorage.setItem("userId", options.userId);
    }    
    this.getZoneDetail();
    this.getApartmentInfo();
  },
  mounted() {
    if (timerInt) {
      clearInterval(timerInt)
    }
    var timerInt = setInterval(() => {
      let contrastCount = JSON.parse(localStorage.getItem('cellContrastArr'));
      if (contrastCount) {
        this.hasContrast = false;
        this.contrastCount = contrastCount.length;
        for (let i = 0; i < contrastCount.length; i++) {
          if (this.zoneId == contrastCount[i]) {
            this.hasContrast = true;
          }
        }
      }
    }, 300);
    this.onReachBottom(e=>{
      this.addBuried({
        source:'1',
        eventType: '触底事件',
        eventContent: '小区详情'
      });
    });
    map = new BMap.Map("detail_map");
    var point = new BMap.Point(this.longitude, this.latitude);
     let myIcon = new BMap.Icon(
        require("../../assets/img/current_location.png"),
        new BMap.Size(18, 31)
      );
    var mk = new BMap.Marker(point, { icon: myIcon });
    mk.disableMassClear();
    map.addOverlay(mk);
    map.centerAndZoom(point, 14);
    map.disableDragging();
    map.disableDoubleClickZoom();
    map.disableScrollWheelZoom();
    map.disablePinchToZoom();
    this.getDevelopmentInfo();
    this.getTrafficInfo();
    this.getCellWalkingIndex();
    this.getThisPolyline();
    this.getNearCell();
    this.getCellInfo();
    this.getMatch();
  },
  methods: {
    createPie() {
      let dom = this.$refs["detailPie"];
      let myChart = this.$echarts.init(dom);
      let option = '';

      option = {
        backgroundColor: "#ffffff",
        color: [
          "#698EFF",
          "#FF8E55",
          "#9785ED",
          "#FFCC5C",
          "#FF7B74",
          "#4ACAA8",
          "#D7A4F6",
          "#FAEE00",
          "#64CCFF",
          "#E89242",
          "#FF76AE",
          "#8DE034"
        ],
        title: {
          text: "中介公司\n房源规模分布",
          // x 设置水平安放位置，默认左对齐，可选值：'center' ¦ 'left' ¦ 'right' ¦ {number}（x坐标，单位px）
          x: "center",
          // y 设置垂直安放位置，默认全图顶端，可选值：'top' ¦ 'bottom' ¦ 'center' ¦ {number}（y坐标，单位px）
          y: "center",
          backgroundColor: "rgba(255,255,255,0)",
          // 主标题文本样式设置
          textStyle: {
            fontSize: 12,
            height: 19,
            lineHeight: 19,
            color: "#111111"
          }
        },
        series: [
          {
            name: "",
            minAngle: 30,
            avoidLabelOverlap: false,
            label: {
              fontSize: 14,
              formatter: "{b|{b}}\n{a|{d}%}",
              borderWidth: 20,
              borderRadius: 4,
              padding: [0, -75],
              rich: {
                a: {
                  color: "#333",
                  fontSize: 10,
                  lineHeight: 14,
                  align: "left"
                },
                b: {
                  fontSize: 10,
                  lineHeight: 14,
                  color: "#333",
                  align: "left"
                }
              }
            },
            type: "pie",
            center: ["50%", "50%"],
            radius: ["35%", "45%"],
            labelLine: {
              normal: {
                length: 15,
                length2: 75
              }
            },
            data: this.pieData,
            itemStyle: {
              normal: {
                borderWidth: 2,
                borderColor: "#fff"
              },
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 2, 2, 0.3)"
              }
            }
          }
        ]
      };
      if (option && typeof option === "object") {
        myChart.setOption(option, true);
      }
    },
    //获取更多
    getMore(){
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "小区概括-更多"
      });
      this.noMore = false;
    },
    //收起更多
    backMore(){
      this.noMore = true;
    },
    //加对比
    plusContrast(){
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "+对比"
      });
      let cellContrastArr =JSON.parse(localStorage.getItem('cellContrastArr'));
      if (!cellContrastArr||cellContrastArr.length==0) {
        cellContrastArr =[Number(this.zoneId)];
        localStorage.setItem('cellContrastArr',JSON.stringify(cellContrastArr));
        this.contrastCount=1;
        this.hasContrast = true;
      }else if (cellContrastArr.length==1) {
        cellContrastArr.push(Number(this.zoneId));
        localStorage.setItem('cellContrastArr',JSON.stringify(cellContrastArr));
        this.contrastCount=2;
        this.hasContrast = true;
      }else if (cellContrastArr.length==2) {
        cellContrastArr.push(Number(this.zoneId));
        localStorage.setItem('cellContrastArr',JSON.stringify(cellContrastArr));
        this.contrastCount=3;
        Toast('已加满3个小区，快去对比吧');
        this.hasContrast = true;
      }else{
        Dialog.confirm({
          title: '添加新小区',
          message: '继续添加小区将覆盖掉最先加入对比的小区，是否确定添加新小区？'
        }).then(() => {
          cellContrastArr.push(Number(this.zoneId));
          cellContrastArr.shift();
          this.hasContrast = true;
          //存储小区对比信息
          localStorage.setItem('cellContrastArr',JSON.stringify(cellContrastArr))
        }).catch(() => {
          // on cancel
        });
      }
    },
    //去其它小区详情
    goOtherCell(item){
      this.isMiniProgram(res => {
        if (res) {
          wx.miniProgram.navigateTo({
            url:"/pages/cell_detail/index?cityId=" +
              this.cityId +
              "&zoneId=" +
              item.id +
              "&latitude=" +
              item.latitude +
              "&longitude=" +
              item.longitude
          });
        } else {
          this.$router.replace({
            path:"/cell_detail",
            query:{
              cityId:this.cityId,
              zoneId:item.id,
              latitude: item.latitude,
              longitude: item.longitude    
            }
          });
          this.reload();
        }
      });
    },
    //去对比
    goContrast(){
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "进入对比页"
      });
      if (this.contrastCount<2) {
        Toast('只有添加2个及以上小区时才能进入对比页面');        
        return false;
      }
      this.isMiniProgram(res => {
        if (res) {
          wx.miniProgram.navigateTo({
            url:"/pages/village_contrast/index" 
          });
        } else {
          this.$router.push({
            path: "/village_contrast"
          });
        }
      });
    },
    //加关注
    plusAttention(item){
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "+关注"
      });
      if (item.isCare==1) {
        return false;
      }
      let userId = localStorage.getItem('userId');
      if (!userId||userId=='undefined') {
        Toast('请登录后查看');
        this.isMiniProgram(res => {
          if (res) {
            wx.miniProgram.redirectTo({
              url: "/pages/login/index?from=cell_detail&cityId="+this.cityId+"&zoneId="+this.zoneId+"&latitude="+this.latitude+"&longitude="+this.longitude
            });
          } else {
          
          }
        });
      }else{
        this.hasAttention = true;
        this.$axios
          .post("api/xz/care/save/", {
            cityId:this.cityId,
            id:this.zoneId,
            type:2,
            userId:userId
          })
          .then(res => {
            if (res.success) {
              Toast('关注成功！')
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    //返回上个页面
    returnPre() {
      if (this.isShare == 0) {
        wx.navigateBack({
          delta: 1
        });
      } else {
        wx.reLaunch({
          url: "/pages/home/index"
        });
      }
    },
    //查看评分标准
    lookScore() {
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "查看评分标准"
      });
      this.show = true;
    },
    //查看步行指数标准
    lookScoreIndex() {
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "查看步行指数标准"
      });
      this.showIndex = true;
    },
    confirmPopup() {
      this.show = false;
    },
    //打开配套分类
    openMatching(){
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "配套详细分类"
      });
      this.showMatching = true;
    },
    //关闭配套分类
    closeMatch(){
      this.showMatching = false;
    },
    //跳转市场量价分析页
    goMarketPrice() {
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "跳转市场量价分析页-小区"
      });
      this.isMiniProgram(res => {
          if (res) {
            wx.miniProgram.navigateTo({
              url:
                "/pages/cell_market_price/index?zoneId=" +
                this.zoneId +
                "&latitude=" +
                this.latitude +
                "&longitude=" +
                this.longitude +
                "&cityId=" +
                this.cityId
            });
          } else {
            this.$router.push({
              path: "/cell_market_price",
              query: {
                cityId: this.cityId,
                zoneId: this.zoneId,
                latitude: this.latitude,
                longitude: this.longitude
              }
            });
          }
        });
    },
    //跳转交通配套
    goTraffic() {
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "跳转交通配套-小区"
      });
      this.isMiniProgram(res => {
          if (res) {
            wx.miniProgram.navigateTo({
              url:
                "/pages/traffic_matching/index?zoneId=" +
                this.zoneId +
                "&latitude=" +
                this.latitude +
                "&longitude=" +
                this.longitude +
                "&name=" +
                this.trafficName +
                "&currentIndex=" +
                this.currentIndex +
                "&isCell=1"
            });
          } else {
           this.$router.push({
              path: "/traffic_matching",
              query: {
                currentIndex: this.currentIndex,
                zoneId: this.zoneId,
                latitude: this.latitude,
                longitude: this.longitude,
                name: this.trafficName,
                isCell:1
              }
            });
          }
        });
    },
    // 跳转商圈排名
    toRank() {
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "跳转小区排名"
      });
      this.isMiniProgram(res => {
        if (res) {
          wx.miniProgram.navigateTo({url: '/pages/cell_list/index?cityId='+this.cityId});
        } else {
          this.$router.push({
            path: "/cell_list",
            query: { cityId: this.cityId }
          });
        }
      });
    },
    //获取配套详细分类
    async getMatch(){
      await this.$axios
        .post("api/xz/walk/score/info/", {
          communityId:this.zoneId,
          cityId:this.cityId
        })
        .then(res => {
          if (res.success) {
            let matchObj = res.result;
            this.matchList[0].info.push({
              name:'幼儿园',
              value:matchObj.kindergarten
            })
            this.matchList[0].info.push({
              name:'小学',
              value:matchObj.primarySchool
            })
            this.matchList[0].info.push({
              name:'中学',
              value:matchObj.middleSchool
            })
            this.matchList[0].info.push({
              name:'大学',
              value:matchObj.universitySchool
            })
            this.matchList[1].info.push({
              name:'医院',
              value:matchObj.hospital
            })
            this.matchList[1].info.push({
              name:'药店',
              value:matchObj.drugstore
            })
            this.matchList[2].info.push({
              name:'商场',
              value:matchObj.shoppingMall
            })
            this.matchList[2].info.push({
              name:'超市',
              value:matchObj.supermarket
            })
            this.matchList[2].info.push({
              name:'市场',
              value:matchObj.market
            })
            this.matchList[3].info.push({
              name:'银行',
              value:matchObj.bank
            })
            this.matchList[3].info.push({
              name:'餐厅',
              value:matchObj.restaurant
            })
            this.matchList[4].info.push({
              name:'公园',
              value:matchObj.park
            })
            this.matchList[4].info.push({
              name:'电影院',
              value:matchObj.cinema
            })
            this.matchList[4].info.push({
              name:'健身房',
              value:matchObj.gym
            })
            this.matchList[4].info.push({
              name:'体育馆',
              value:matchObj.gymnasium
            })
            this.matchList[5].info.push({
              name:'地铁',
              value:matchObj.subway
            })
            this.matchList[5].info.push({
              name:'公交',
              value:matchObj.bus
            })
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取小区概括
    async getCellInfo(){
      await this.$axios
        .post("api/xz/community/sums/", {
          ids:this.zoneId
        })
        .then(res => {
          if (res.success) {
            if (res.result&&res.result.length>0) {
              this.cellInfoList = res.result[0]
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取小区步行指数
    async getCellWalkingIndex(){
      await this.$axios
        .post("api/xz/walk/score/sum/", {
          communityId: this.zoneId,
          cityId:this.cityId
        })
        .then(res => {
          if (res.success) {
            this.walkIndex = res.result;
            let nameList = res.result.name;
            let scoreList = res.result.score;
            for (let i = 0; i < nameList.length; i++) {
              this.progressList.push({
                name:nameList[i],
                value:scoreList[i]
              })
              this.matchList[i].scope = scoreList[i]
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //交通配套选择
    selectTraffic(item, index) {
      this.currentIndex = index;
      this.trafficName = item.name;
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: item.name
      });
      this.getTrafficDetail(item.name);
    },
    //获取交通汇总信息
    async getTrafficInfo() {
      await this.$axios
        .post("api/xz/traffic/sum/community/", {
          communityId: this.zoneId,
          distance:2000
        })
        .then(res => {
          if (res.success) {
            let list = res.result;
            this.trafficList = list;
            this.trafficName = this.trafficList[0].name;
            this.getTrafficDetail(this.trafficList[0].name, 1);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取交通配套详情信息
    async getTrafficDetail(name, isFirst) {
      const toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner"
      });
      await this.$axios
        .post("api/xz/community/traffic/info/", {
          communityId: this.zoneId,
          name: name,
          distance:2000
        })
        .then(res => {
          if (res.success) {
            map.clearOverlays();
            if (res && res.result) {
              let trafficDetailList = res.result.list;
              let len = trafficDetailList.length;
              for (let i = 0; i < len; i++) {
                var marker = new BMap.Marker(
                  new BMap.Point(
                    trafficDetailList[i].longitude,
                    trafficDetailList[i].latitude
                  )
                );
                map.addOverlay(marker);
              }
            }
          }
          Toast.clear();
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取小区详情信息
    async getZoneDetail() {
      await this.$axios
        .post("api/xz/community/sum/v2/", {
          id: this.zoneId,
          cityId:this.cityId,
          uuid: localStorage.getItem("uuid"),
          userId: this.userId
        })
        .then(res => {
          if (res.success) {
            this.zoneDetail = res.result;
            if (this.zoneDetail.isCare==1) {
              this.hasAttention = true;
            }else{
              this.hasAttention = false;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取品牌公寓信息
    async getApartmentInfo() {
      await this.$axios
        .post("api/xz/brand/list/", {
          zoneId: this.zoneId,
          cityId: this.cityId,
          type:2
        })
        .then(res => {
          if (res.success) {
            this.apartmentInfo = res.result;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取行业发展信息
    async getDevelopmentInfo() {
      await this.$axios
        .post("api/xz/industry/pie/community/", {
          communityId: this.zoneId
        })
        .then(res => {
          if (res.success) {
            this.developmentInfo = res.result;
            this.pieData = res.result.pie;
            setTimeout(() => {
              this.createPie();
            }, 500);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取周边推荐小区
    async getNearCell(){
      await this.$axios
        .post("api/xz/community/near/", {
          communityId: this.zoneId,
          cityId:this.cityId
        })
        .then(res => {
          if (res.success) {
            this.nearCellList =res.result;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取当前商圈描边信息
    async getThisPolyline() {
      let that = this;
      await that.$axios
        .post("api/xz/zone/polyline/", {
          zoneId: that.zoneId
        })
        .then(res => {
          if (res.success) {
            let coordinateList = res.result;
            let len = coordinateList.length;
            let arr = [];
            for (let i = 0; i < len; i++) {
              arr.push(
                new BMap.Point(
                  coordinateList[i].longitude,
                  coordinateList[i].latitude
                )
              );
            }
            var polygon = new BMap.Polygon(arr, {
              strokeColor: "#4169E1",
              strokeStyle: "dashed",
              fillColor: "#4169E1",
              strokeWeight: 3,
              strokeOpacity: 1,
              fillOpacity: 0.1
            });
            polygon.disableMassClear();
            map.addOverlay(polygon);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  destroyed () {
    timestampEnd = (new Date()).getTime();
    let residenceTime = timestampEnd-timestampStart;
    this.addBuried({
      source:'1',
      eventType: '页面停留时长',
      eventContent: '小区详情停留时长'+residenceTime/1000+'s'
    });
  }
};
</script>




// WEBPACK FOOTER //
// src/pages/cell_detail/index.vue